import React from 'react';
import { FiPlusSquare } from 'react-icons/fi';
import ActionButton from './ActionButton';

const AddToTodoButton = ({ onClick, title = 'Add to Todo', disabled = false, className = '' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <ActionButton
      icon={FiPlusSquare}
      onClick={handleClick}
      title={title}
      className={className}
      disabled={disabled}
    />
  );
};

export default AddToTodoButton;
